import { Component, attr } from '../Component'
import { element } from '../CustomElement'
import { Dialog } from '../flipp-dialog/Dialog'
import { LinkService } from '../../services/LinkService'
import {
    ConfigService,
    Experience,
    RuntimeConfig,
} from '../../services/ConfigService'
import { i18n } from '../../i18n/I18n'
import { inject } from '../../services/di'
import { UserAgentService } from '../../services/UserAgentService'
import { LocationService, PostalCode } from '../../services/LocationService'
import { BlackFridayService } from '../../services/BlackFridayService'
import { StorageService } from '../../services/StorageService'
import { AnalyticsService } from '../../services/AnalyticsService'
import { BlacklistService } from '../../services/BlacklistService'
import { icons } from '../../icons/Icons'

interface LocationPickerProps extends JSX.HTMLProps {
    placement?: 'sidebar' | 'topbar'
}

@element('flipp-location-picker')
export class LocationPicker extends Component<LocationPickerProps, any> {
    @inject config: ConfigService
    @inject userAgent: UserAgentService
    @inject location: LocationService
    @inject bf: BlackFridayService
    @inject storage: StorageService
    @inject analytics: AnalyticsService
    @inject blacklist: BlacklistService

    @attr placement: 'sidebar' | 'topbar'

    state = {
        locationDialogOpened: false,
    }

    refs: {
        locationDialog: Dialog
        anchor: HTMLButtonElement
        postalCodeInput: HTMLInputElement
    }

    onAttach() {
        this.addEventListener('close', this._handleDialogCloseEvent)
        window.addEventListener('resize', this._handleResize)
    }

    onDetach() {
        this.removeEventListener('close', this._handleDialogCloseEvent)
        window.removeEventListener('resize', this._handleResize)
    }

    render() {
        const isSDE = this.config.EXPERIENCE === Experience.SDE
        if (isSDE) {
            const flyersForPostalCode = i18n('flyers_for_postal_code', {
                postalCode: this.location.postalCode,
            })
            const changeLocation = i18n('change_location')
            return this.placement === 'topbar' ? (
                <div
                    class="location-sde topbar"
                    onClick={this._handleLocationButtonClick_}
                    ref="anchor"
                    anchor-point="left bottom"
                >
                    <img
                        class="icon"
                        src="https://f.wishabi.net/creative/Distribution/images/icons/location-01-default5.svg"
                        alt=""
                    />
                    <span>{flyersForPostalCode}</span>
                    {this.renderLocationChangeDialog()}
                </div>
            ) : (
                <button
                    class="location-sde on-sidebar"
                    ref="anchor"
                    anchor-point="left bottom"
                    onClick={this._handleLocationButtonClick_}
                >
                    {this.bf.isOnHost() ? (
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                        >
                            <path
                                d="M9 15.75C8.87909 15.7498 8.76002 15.7204 8.65293 15.6642C8.54585 15.6081 8.45393 15.5269 8.385 15.4275L4.3875 9.61501L4.3425 9.54751C3.96047 8.84289 3.76038 8.05404 3.76038 7.25251C3.76038 6.45098 3.96047 5.66214 4.3425 4.95751C4.74423 4.20134 5.32858 3.55756 6.04244 3.08471C6.7563 2.61186 7.57703 2.32493 8.43 2.25001C8.80941 2.22001 9.1906 2.22001 9.57 2.25001C10.423 2.32154 11.2448 2.60448 11.9611 3.07326C12.6774 3.54204 13.2655 4.1819 13.6725 4.93501C14.0545 5.63964 14.2546 6.42848 14.2546 7.23001C14.2546 8.03154 14.0545 8.82039 13.6725 9.52501C13.6593 9.54864 13.6442 9.57121 13.6275 9.59251L9.63 15.405C9.56224 15.5106 9.46906 15.5976 9.35899 15.6578C9.24893 15.7181 9.12549 15.7498 9 15.75ZM5.64 8.79751L9 13.68L12.3525 8.79751C12.6144 8.31656 12.7516 7.77765 12.7516 7.23001C12.7516 6.68237 12.6144 6.14346 12.3525 5.66251C12.0693 5.12169 11.6526 4.66216 11.1421 4.32747C10.6315 3.99277 10.0439 3.79401 9.435 3.75001C9.14578 3.72 8.85423 3.72 8.565 3.75001C7.95666 3.79609 7.36994 3.9957 6.85971 4.33017C6.34948 4.66463 5.93241 5.12304 5.6475 5.66251C5.38641 6.14347 5.24902 6.68181 5.24771 7.22906C5.2464 7.77632 5.38121 8.31531 5.64 8.79751Z"
                                fill="white"
                            />
                            <path
                                d="M9 9.375C10.0355 9.375 10.875 8.53553 10.875 7.5C10.875 6.46447 10.0355 5.625 9 5.625C7.96447 5.625 7.125 6.46447 7.125 7.5C7.125 8.53553 7.96447 9.375 9 9.375Z"
                                fill="white"
                            />
                        </svg>
                    ) : (
                        <img
                            class="icon"
                            src="https://f.wishabi.net/creative/Distribution/images/icons/location-01-default5.svg"
                            alt=""
                        />
                    )}
                    <div>
                        {flyersForPostalCode}
                        <br />
                        <span>({changeLocation})</span>
                    </div>
                    {this.renderLocationChangeDialog()}
                </button>
            )
        }

        return (
            <div
                class={`location-default ${this.bf.isOnHost() ? 'bf' : ''} ${this.placement === 'sidebar' ? 'on-sidebar' : ''} ${this.state.locationDialogOpened ? 'opened' : ''}`}
            >
                <button
                    class="location"
                    ref="anchor"
                    anchor-point="rigth bottom"
                    onClick={this._handleLocationButtonClick_}
                >
                    <div class="postal-code-text">
                        {this.bf.isOnHost() ? (
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                            >
                                <path
                                    d="M9 15.75C8.87909 15.7498 8.76002 15.7204 8.65293 15.6642C8.54585 15.6081 8.45393 15.5269 8.385 15.4275L4.3875 9.61501L4.3425 9.54751C3.96047 8.84289 3.76038 8.05404 3.76038 7.25251C3.76038 6.45098 3.96047 5.66214 4.3425 4.95751C4.74423 4.20134 5.32858 3.55756 6.04244 3.08471C6.7563 2.61186 7.57703 2.32493 8.43 2.25001C8.80941 2.22001 9.1906 2.22001 9.57 2.25001C10.423 2.32154 11.2448 2.60448 11.9611 3.07326C12.6774 3.54204 13.2655 4.1819 13.6725 4.93501C14.0545 5.63964 14.2546 6.42848 14.2546 7.23001C14.2546 8.03154 14.0545 8.82039 13.6725 9.52501C13.6593 9.54864 13.6442 9.57121 13.6275 9.59251L9.63 15.405C9.56224 15.5106 9.46906 15.5976 9.35899 15.6578C9.24893 15.7181 9.12549 15.7498 9 15.75ZM5.64 8.79751L9 13.68L12.3525 8.79751C12.6144 8.31656 12.7516 7.77765 12.7516 7.23001C12.7516 6.68237 12.6144 6.14346 12.3525 5.66251C12.0693 5.12169 11.6526 4.66216 11.1421 4.32747C10.6315 3.99277 10.0439 3.79401 9.435 3.75001C9.14578 3.72 8.85423 3.72 8.565 3.75001C7.95666 3.79609 7.36994 3.9957 6.85971 4.33017C6.34948 4.66463 5.93241 5.12304 5.6475 5.66251C5.38641 6.14347 5.24902 6.68181 5.24771 7.22906C5.2464 7.77632 5.38121 8.31531 5.64 8.79751Z"
                                    fill="white"
                                />
                                <path
                                    d="M9 9.375C10.0355 9.375 10.875 8.53553 10.875 7.5C10.875 6.46447 10.0355 5.625 9 5.625C7.96447 5.625 7.125 6.46447 7.125 7.5C7.125 8.53553 7.96447 9.375 9 9.375Z"
                                    fill="white"
                                />
                            </svg>
                        ) : (
                            <img
                                class="icon"
                                src="https://f.wishabi.net/creative/Distribution/images/icons/location-01-default5.svg"
                                alt=""
                            />
                        )}
                        <div>{this.location.postalCode}</div>
                    </div>
                    <div>
                        {this.state.locationDialogOpened
                            ? icons.chevronUp
                            : icons.chevronDown}
                    </div>
                </button>
                {this.renderLocationChangeDialog()}
            </div>
        )
    }

    private renderLocationChangeDialog() {
        const analyticParams = this.analytics.analyticsParameters
        return (
            <Dialog
                anchor-point="left top"
                ref="locationDialog"
                class={`location-dialog popover ${this.placement === 'sidebar' ? 'on-sidebar' : ''}`}
            >
                <div class="arrow"></div>
                <form
                    class="postal-code"
                    method="get"
                    action={LinkService.getInstance().linkTo(
                        this.config.RUNTIME === RuntimeConfig.DISTRIBUTION
                            ? 'distribution'
                            : 'redirect'
                    )}
                    onSubmit={this._handlePostalCodeSubmit}
                >
                    <input type="hidden" name="page" value="listing" />
                    <input
                        type="hidden"
                        name="locale"
                        value={this.location.locale}
                    />
                    <input
                        type="hidden"
                        name="old_fsa"
                        value={
                            this.config.RUNTIME === RuntimeConfig.DEFAULT
                                ? this.location.postalCode
                                : null
                        }
                    />
                    <input type="hidden" name="location_source" value="1" />{' '}
                    {/* 1 is 'USER_SUPPLIED' */}
                    <input
                        type="hidden"
                        name="blacklist_merchant_ids"
                        value={this.blacklist.getBlacklist().join(',')}
                    />
                    {this.config.RUNTIME === RuntimeConfig.DISTRIBUTION
                        ? Object.getOwnPropertyNames(analyticParams).map(
                              (prop) => (
                                  <input
                                      type="hidden"
                                      name={prop}
                                      value={analyticParams[prop]}
                                  />
                              )
                          )
                        : null}
                    <div>
                        <p>{i18n('enter_your_postal_code')}</p>
                        <input
                            id="postal_code_input"
                            type="text"
                            name="postal_code"
                            placeholder={i18n('postal_code')}
                            value={this.location.postalCode}
                            maxLength={7}
                            ref="postalCodeInput"
                        />
                        <button type="submit" class="find-flyers">
                            {i18n('find_flyers')}
                        </button>
                    </div>
                </form>
            </Dialog>
        )
    }

    private _handlePostalCodeSubmit = (e: Event) => {
        const input = this.refs.postalCodeInput
        // clean up
        input.value = input.value.replace(' ', '')

        if (!PostalCode.isValid(input.value)) {
            input.setAttribute('invalid', '')

            e.preventDefault()
            return
        }

        const currentCode = new PostalCode(this.location.postalCode)
        const newCode = new PostalCode(input.value)
        const hasChangedCountry = currentCode.country !== newCode.country

        if (this.config.RUNTIME === RuntimeConfig.DISTRIBUTION) {
            /* Prevent users from changing to a different country FSA in the distribution experience */
            if (hasChangedCountry) {
                input.setAttribute('invalid', '')
                e.preventDefault()
                return
            }
        } else if (hasChangedCountry) {
            const { value } = (e.target as any).locale
            if (this.location.isUsLocale(value)) {
                ;(e.target as any).locale.value = 'en-ca'
            } else if (this.location.isCanadianLocale(value)) {
                ;(e.target as any).locale.value = 'en-us'
            }
        }

        const postalCode = new PostalCode(input.value)
        this.storage.removeItem('locale')
        this.location.savePostalCode(postalCode)
    }

    private _handleResize = () => {
        if (!this.userAgent.mobile) {
            if (this.refs.locationDialog.open) this.refs.locationDialog.close()
        }
    }
    _handleDialogCloseEvent() {
        this.state.locationDialogOpened = false
        this.invalidate()
    }

    private _handleLocationButtonClick_ = () => {
        this.refs.locationDialog.showModal(this.refs.anchor)
        this.state.locationDialogOpened = true
        this.invalidate()
    }
}
